import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GuestPayment, GuestPaymentRefund } from 'models';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root',
})
export class GuestPaymentsService {
	constructor(private http: HttpClient) {}

	public get(guestUserId: string): Observable<GuestPayment[]> {
		return this.http.get<GuestPayment[]>(`api/guestpayment/get/${guestUserId}`);
	}

	public blockRefund(verificationToPaymentId: number) {
		return this.http.post<void>(`api/guestpayment/blockrefund`, verificationToPaymentId);
	}

	public setToManuallyPaid(verificationToPaymentId: number) {
		return this.http.post<void>(`api/guestpayment/settomanuallypaid`, verificationToPaymentId);
	}

	public refund(guestPaymentRefundViewModel: GuestPaymentRefund) {
		return this.http.post<void>(`api/guestpayment/refund`, guestPaymentRefundViewModel);
	}
}
